import { render, staticRenderFns } from "./UserProfileDownloads.vue?vue&type=template&id=667d314c&scoped=true&"
import script from "./UserProfileDownloads.vue?vue&type=script&lang=js&"
export * from "./UserProfileDownloads.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileDownloads.vue?vue&type=style&index=0&id=667d314c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667d314c",
  null
  
)

export default component.exports